import { render } from "./ModalPending.vue?vue&type=template&id=719b996a"
import script from "./ModalPending.vue?vue&type=script&lang=js"
export * from "./ModalPending.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__